/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var DocumentOutlineIcon = function DocumentOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M13 13H7V11H13V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 17H16V15H7V17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C4.34315 2 3 3.34315 3 5V19C3 20.6569 4.34315 22 6 22H18C19.6569 22 21 20.6569 21 19V8.82843C21 8.03278 20.6839 7.26972 20.1213 6.70711L16.2929 2.87868C15.7303 2.31607 14.9672 2 14.1716 2H6ZM5 5C5 4.44772 5.44772 4 6 4H14V7C14 8.10457 14.8954 9 16 9H19V19C19 19.5523 18.5523 20 18 20H6C5.44772 20 5 19.5523 5 19V5Z"
  }));
};
export default DocumentOutlineIcon;